import React, { useState, useEffect } from "react";
import axiosConfig from "../../AxiosConfig";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  FormGroup,
} from "reactstrap";

import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

import Select from "react-select";

import {
  _GetByUrlOnly,
  CreateAccountSave,
} from "../../ApiEndPoint/ApiCalling";

import { viewpincodedata1 } from "../../ApiEndPoint/Api";

export default function CreateUser() {

  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("userData"));

  const loggedInRole = user?.rolename?.roleName;

  const [loading, setLoading] = useState(false);

  const [roleOptions, setRoleOptions] = useState([]);

  const [Master, setMaster] = useState(false);

  const [AllAssignRoleList, setAllAssignRoleList] = useState([]);

  const [SelectedRoleToAssign, setSelectedRoleToAssign] = useState([]);
  const [SelectedFullRoles, setSelectedFullRoles] = useState([]);
  const [showCityDropdown, setShowCityDropdown] = useState(false);

  const [cityOptions, setCityOptions] = useState([]);

  const [formData, setFormData] = useState({
    firstName: "",
    email: "",
    mobileNumber: "",
    password: "",
    dob: "",
    fatherName: "",
    drivingLicense: "",
    Aadhar_No: "",
    Pan_No: "",

    pincode: "",
    City: "",
    District: "",
    State: "",
    address: "",

    rolename: {
      _id: "",
      roleName: "",
    },

    designation: "",

    BankName: "",
    accountNumber: "",
    ifscCode: "",

    database: "",

    incentiveType: "",
    incentiveValue: "",

    assignedRoles: [],
  });

  // ================= HANDLE CHANGE =================

  const handleChange = (key, value) => {

    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // ================= FETCH ROLES =================

  useEffect(() => {

    fetchRoles();

  }, []);

 const fetchRoles = async () => {
  try {
    let res;

    // ================= MASTER =================
    if (loggedInRole === "MASTER") {
      res = await axiosConfig.get(
        `/master/get-super-admin-role/${user?._id}`
      );
    }

    // ================= SUPERADMIN =================
    else if (loggedInRole === "SuperAdmin") {
      res = await axiosConfig.get(
        `/role/get-role/${user?.database}`
      );
    }

    // ================= OTHER =================
    else {
      res = await axiosConfig.get(
        `/role/get-role/${user?.database}`
      );
    }

    const roles = res?.data?.Role || [];

    let filtered = [];

    if (loggedInRole === "MASTER") {
      setMaster(true);

      filtered = roles.filter(
        (r) => r.roleName === "SuperAdmin"
      );

      const withoutMaster = roles.filter(
        (r) => r.roleName !== "MASTER"
      );

      setAllAssignRoleList(withoutMaster);
    } else if (loggedInRole === "SuperAdmin") {
      filtered = roles.filter(
        (r) =>
          r.roleName !== "MASTER" &&
          r.roleName !== "SuperAdmin"
      );
    } else {
      filtered = roles.filter(
        (r) =>
          r.roleName !== "MASTER" &&
          r.roleName !== "SuperAdmin"
      );
    }

    console.log("Roles =>", filtered);

    setRoleOptions(filtered);
  } catch (err) {
    console.log("Role Fetch Error", err);
  }
};

  // ================= PINCODE =================

  const fetchPincode = async (pincode) => {

    try {
      const res = await _GetByUrlOnly(
        `${viewpincodedata1}?pincode=${pincode}`
      );

      // ================= SINGLE CITY =================

      if (res?.pinCodes?.length === 1) {

        const data = res.pinCodes[0];

        setShowCityDropdown(false);

        setFormData((prev) => ({
          ...prev,
          City: data?.city || "",
          District: data?.district || "",
          State: data?.state || "",
        }));
      }

      // ================= MULTIPLE CITY =================

      else if (res?.pinCodes?.length > 1) {

        const options = res.pinCodes.map((item) => ({
          city: item.city,
          district: item.district,
          state: item.state,
        }));

        setCityOptions(options);

        setShowCityDropdown(true);
      }

      // ================= NO DATA =================

      else {

        setShowCityDropdown(false);

        setCityOptions([]);

        setFormData((prev) => ({
          ...prev,
          City: "",
          District: "",
          State: "",
        }));
      }

    } catch (err) {

      console.log("Pincode Error", err);
    }
  };

  // ================= SUBMIT =================
  const submitHandler = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      // ================= VALIDATION =================

      if (!formData.firstName) {
        return swal("Error", "Full Name Required");
      }

      if (!formData.email) {
        return swal("Error", "Email Required");
      }

      if (!formData.mobileNumber) {
        return swal("Error", "Mobile Number Required");
      }

      if (!formData.password) {
        return swal("Error", "Password Required");
      }

      if (!formData.rolename?._id) {
        return swal("Error", "Role Required");
      }

      // ================= USER CREATE PAYLOAD =================

      const payload = {

        ...formData,

        id: formData?.Aadhar_No,

        created_by: user?._id,

        database:
          formData.database || user?.database,

        rolename:
          formData?.rolename?._id,
      };

      console.log("USER PAYLOAD", payload);

      // ================= CREATE USER =================

      const res = await CreateAccountSave(payload);

      console.log("CREATE USER RESPONSE", res);

      // ================= SUCCESS =================

      if (res?.status) {

        // =====================================================
        // MASTER -> SUPERADMIN ROLE ASSIGN API
        // =====================================================

        if (
          Master &&
          formData?.rolename?.roleName === "SuperAdmin" &&
          SelectedFullRoles?.length > 0
        ) {

          // ✅ SAME OLD FORMAT
          const AssignDataBase =
            SelectedFullRoles.map((ele) => ({

              role: {

                roleName: ele?.roleName,

                position: ele?.position || 0,

                desc: ele?.desc || "",

                id: ele?.id || ele?.roleName,

                rank: ele?.rank || 0,

                rolePermission:
                  ele?.rolePermission || [],

                database:
                  formData.database || user?.database,

                createdBy: user?._id,
              },
            }));

          console.log(
            "ASSIGN ROLE PAYLOAD",
            AssignDataBase
          );

          // ✅ API CALL
          await axiosConfig.post(
            "/role/assign-role",
            {
              Roles: JSON.stringify(
                AssignDataBase
              ),
            }
          );
        }

        swal(
          "Success",
          "User Created Successfully",
          "success"
        );

        navigate(-1);

      } else {

        swal(
          "Error",
          res?.message || "Something Went Wrong"
        );
      }

    } catch (err) {

      console.log(err);

      swal(
        "Error",
        err?.response?.data?.message ||
        "Something Went Wrong"
      );

    } finally {

      setLoading(false);
    }
  };
  return (
    <div className="erp-page-grid">

      <form onSubmit={submitHandler}>

        <Row>

          <Col md="12">

            {/* ================= PERSONAL INFO ================= */}

            <Card className="erp-card">

              <CardBody>

                <h5>Personal Information</h5>

                <Row>

                  {/* FULL NAME */}

                  <Col md="4">
                    <Label>Full Name</Label>

                    <Input
                      value={formData.firstName}
                      onChange={(e) =>
                        handleChange(
                          "firstName",
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  {/* EMAIL */}

                  <Col md="4">
                    <Label>Email</Label>

                    <Input
                      type="email"
                      value={formData.email}
                      onChange={(e) =>
                        handleChange(
                          "email",
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  {/* MOBILE */}

                  <Col md="4">
                    <Label>Mobile</Label>

                    <Input
                      value={formData.mobileNumber}
                      onChange={(e) =>
                        handleChange(
                          "mobileNumber",
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  {/* PASSWORD */}

                  <Col md="4">
                    <Label>Password</Label>

                    <Input
                      type="password"
                      value={formData.password}
                      onChange={(e) =>
                        handleChange(
                          "password",
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  {/* DOB */}

                  <Col md="4">
                    <Label>DOB</Label>

                    <Input
                      type="date"
                      value={formData.dob}
                      onChange={(e) =>
                        handleChange(
                          "dob",
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  {/* FATHER NAME */}

                  <Col md="4">
                    <Label>Father Name</Label>

                    <Input
                      value={formData.fatherName}
                      onChange={(e) =>
                        handleChange(
                          "fatherName",
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  {/* AADHAR */}

                  <Col md="4">
                    <Label>Aadhar Number</Label>

                    <Input
                      value={formData.Aadhar_No}
                      onChange={(e) =>
                        handleChange(
                          "Aadhar_No",
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  {/* PAN */}

                  <Col md="4">
                    <Label>PAN Number</Label>

                    <Input
                      value={formData.Pan_No}
                      onChange={(e) =>
                        handleChange(
                          "Pan_No",
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  {/* DL */}

                  <Col md="4">
                    <Label>Driving License</Label>

                    <Input
                      value={formData.drivingLicense}
                      onChange={(e) =>
                        handleChange(
                          "drivingLicense",
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  {/* ROLE */}

                  <Col md="4">

                    <Label>Select Role</Label>

                    <Input
                      type="select"
                      value={
                        formData?.rolename?._id || ""
                      }
                      onChange={(e) => {

                        const selected =
                          roleOptions.find(
                            (r) =>
                              r._id === e.target.value
                          );

                        setFormData((prev) => ({
                          ...prev,

                          rolename: {
                            _id:
                              selected?._id || "",

                            roleName:
                              selected?.roleName || "",
                          },
                        }));
                      }}
                    >

                      <option value="">
                        Select Role
                      </option>

                      {roleOptions.map((r) => (

                        <option
                          key={r._id}
                          value={r._id}
                        >
                          {r.roleName}
                        </option>

                      ))}

                    </Input>

                  </Col>

                  {/* ASSIGN ROLES */}

                
                  {Master &&
                    formData?.rolename?.roleName === "SuperAdmin" && (

                      <Col md="6">
                        <FormGroup>

                          <Label>
                            Select Roles To Assign
                          </Label>

                          <Select
                            isMulti
                            options={AllAssignRoleList.map((role) => ({
                              value: role._id,
                              label: role.roleName,
                              fullData: role,
                            }))}

                            value={SelectedRoleToAssign}

                            onChange={(selectedOptions) => {

                              setSelectedRoleToAssign(
                                selectedOptions || []
                              );

                              const fullRoles =
                                selectedOptions?.map(
                                  (item) => item.fullData
                                ) || [];

                              setSelectedFullRoles(fullRoles);

                              setFormData((prev) => ({
                                ...prev,
                                assignedRoles: fullRoles,
                              }));
                            }}

                            placeholder="Select Roles"

                            closeMenuOnSelect={false}
                          />

                        </FormGroup>
                      </Col>
                    )}

                  {/* PINCODE */}

                  <Col md="4">

                    <Label>Pincode</Label>

                    <Input
                      value={formData.pincode}
                      onChange={(e) => {

                        const val = e.target.value;

                        handleChange(
                          "pincode",
                          val
                        );

                        if (val.length === 6) {
                          fetchPincode(val);
                        }
                      }}
                    />

                  </Col>

                  {/* CITY */}

                  <Col md="4">

                    <Label>City</Label>

                    {showCityDropdown ? (

                      <Input
                        type="select"
                        value={formData.City}
                        onChange={(e) => {

                          const selected =
                            cityOptions.find(
                              (c) =>
                                c.city ===
                                e.target.value
                            );

                          setFormData((prev) => ({
                            ...prev,

                            City:
                              selected?.city || "",

                            District:
                              selected?.district ||
                              "",

                            State:
                              selected?.state || "",
                          }));
                        }}
                      >

                        <option value="">
                          Select City
                        </option>

                        {cityOptions.map((c, i) => (

                          <option
                            key={i}
                            value={c.city}
                          >
                            {c.city}
                          </option>

                        ))}

                      </Input>

                    ) : (

                      <Input
                        value={formData.City}
                        readOnly
                      />

                    )}

                  </Col>

                  {/* DISTRICT */}

                  <Col md="4">

                    <Label>District</Label>

                    <Input
                      value={formData.District}
                      readOnly
                    />

                  </Col>

                  {/* STATE */}

                  <Col md="4">

                    <Label>State</Label>

                    <Input
                      value={formData.State}
                      readOnly
                    />

                  </Col>

                  {/* ADDRESS */}

                  <Col md="4">

                    <Label>Address</Label>

                    <Input
                      value={formData.address}
                      onChange={(e) =>
                        handleChange(
                          "address",
                          e.target.value
                        )
                      }
                    />

                  </Col>

                  {/* INCENTIVE TYPE */}

                  <Col md="4">

                    <Label>Incentive Type</Label>

                    <Input
                      type="select"
                      value={
                        formData.incentiveType
                      }
                      onChange={(e) =>
                        handleChange(
                          "incentiveType",
                          e.target.value
                        )
                      }
                    >

                      <option value="">
                        Select Type
                      </option>

                      <option value="Fixed">
                        Fixed
                      </option>

                      <option value="Percentage">
                        Percentage
                      </option>

                    </Input>

                  </Col>

                  {/* INCENTIVE VALUE */}

                  <Col md="4">

                    <Label>
                      Incentive Value
                    </Label>

                    <Input
                      type="number"
                      value={
                        formData.incentiveValue
                      }
                      onChange={(e) =>
                        handleChange(
                          "incentiveValue",
                          e.target.value
                        )
                      }
                    />

                  </Col>

                  {/* DATABASE */}

                  <Col md="4">

                    <Label>Database</Label>

                    <Input
                      value={formData.database}
                      onChange={(e) =>
                        handleChange(
                          "database",
                          e.target.value
                        )
                      }
                    />

                  </Col>

                </Row>

              </CardBody>

            </Card>

            {/* ================= BANK DETAILS ================= */}

            <Card className="erp-card mt-3">

              <CardBody>

                <h5>Bank Details</h5>

                <Row>

                  <Col md="4">

                    <Label>Bank Name</Label>

                    <Input
                      value={formData.BankName}
                      onChange={(e) =>
                        handleChange(
                          "BankName",
                          e.target.value
                        )
                      }
                    />

                  </Col>

                  <Col md="4">

                    <Label>Account Number</Label>

                    <Input
                      value={
                        formData.accountNumber
                      }
                      onChange={(e) =>
                        handleChange(
                          "accountNumber",
                          e.target.value
                        )
                      }
                    />

                  </Col>

                  <Col md="4">

                    <Label>IFSC Code</Label>

                    <Input
                      value={formData.ifscCode}
                      onChange={(e) =>
                        handleChange(
                          "ifscCode",
                          e.target.value
                        )
                      }
                    />

                  </Col>

                </Row>

              </CardBody>

            </Card>

            {/* ================= BUTTON ================= */}

            <div className="text-end mt-3">

              <Button
                color="primary"
                disabled={loading}
              >
                {loading
                  ? "Saving..."
                  : "Save User"}
              </Button>

            </div>

          </Col>

        </Row>

      </form>

    </div>
  );
}